import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export default class OpenBusinessProcessSettingAPI extends BasicsClass {
  public apiUrls: any = new Map([
    ['getOpenBusinessProcessSettingList', {
      url: '/admin/opening/planList',
      name: 'list',
      label: '列表'
    }],
    // ['getOpenBusinessProcessCityList', {
    //   url: '/admin/poolRoomDistribute/area',
    //   name: 'open-business-city-list',
    //   label: '开业进度城市列表'
    // }],
    ['addOpenBusinessProcessSetting', {
      url: '/admin/opening/planAdd',
      name: 'add-open-business-process',
      label: '添加开业进度问题'
    }],
    ['updateOpenBusinessProcessSetting', {
      url: '/admin/opening/planEdit',
      name: 'edit-open-business-process',
      label: '编辑开业进度问题'
    }],
    
    // ['changeGuessingGameAnswer', {
    //   url: '/admin/guess/question/answer',
    //   name: 'set-open-business-process-answer',
    //   label: '设置开业进度问题答案'
    // }]
   
  ])

  // 开业进度列表
  public getOpenBusinessProcessSettingList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getOpenBusinessProcessSettingList').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }
  // 开业进度城市列表
  // public getOpenBusinessProcessCityList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('getOpenBusinessProcessCityList').url

  //   this.BasicPost(url, {
  //     ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }

  // 修改开业进度
  public updateOpenBusinessProcessSetting(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('updateOpenBusinessProcessSetting').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 添加开业进度
  public addOpenBusinessProcessSetting(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('addOpenBusinessProcessSetting').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 设置开业进度答案
  // public changeGuessingGameAnswer(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('changeGuessingGameAnswer').url

  //   this.BasicPost(url, {
  //     ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }
  
}